<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <Dialog
        :value="true"
        :width="1200"
        :header-text="$t('Master template')"
        :class-name="isMasterTemplate ? 'purple lighten-1' : null"
        @close_modal="onCloseClick"
    >
        <template slot="header">
            <div class="d-flex align-center justify-space-between w-100">
                <div>
                    <div v-if="isMasterTemplate" class="caption">
                        {{ $t('Master template') }}
                    </div>

                    <!-- Client contract modal -->
                    <div class="headline mr-12"
                         v-if="!isMasterTemplate && clientId && billingItemCopy.product_id !== null && changedValues.includes(true)">
                        {{ $t('Client product') }}
                    </div>
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && clientId && billingItemCopy.product_id !== null && !changedValues.includes(true)">
                        {{ $t('Product / service') }}
                    </div>
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && clientId && billingItemCopy.id && billingItemCopy.product_id === null">
                        {{ $t('Client product / service') }}
                    </div>
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && clientId && billingItemCopy.product_id === null">
                        {{ $t('New client product') }}
                    </div>

                    <!-- Master contract modal -->
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && !clientId && billingItemCopy.product_id !== null && changedValues.includes(true)">
                        {{ $t('Template product') }}
                    </div>
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && !clientId && billingItemCopy.product_id !== null && !changedValues.includes(true)">
                        {{ $t('Product / service') }}
                    </div>
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && !clientId && billingItemCopy.id && billingItemCopy.product_id === null">
                        {{ $t('Template product / service') }}
                    </div>
                    <div class="headline mr-12"
                         v-else-if="!isMasterTemplate && !clientId && billingItemCopy.product_id === null">
                        {{ $t('New template product') }}
                    </div>

                    <!-- Master product modal -->
                    <div class="headline mr-12"
                         v-else>
                        {{ $t('Product / service') }}
                    </div>

                </div>
                <div>
                    <slot name="append-header"/>
                </div>
            </div>
        </template>
        <form v-if="billingItem">
            <v-row class="mt-6 pr-4">
                <v-col
                    cols="6"
                    class="pt-0"
                >
                    <v-row no-gutters>
                        <v-col class="pb-0 px-1">
                            <text-field
                                ref="nameRef"
                                v-model="billingItemCopy.name"
                                :error-messages="billingItem.name_error"
                                :class="customizeForClient && isProductNameChanged ? 'highlight-changed' : ''"
                                :label="$t('Product / service')"
                            />
                        </v-col>
                        <v-col class="pt-6 px-1 shrink d-flex flex-nowrap">
                            <v-tooltip
                                v-if="isMasterTemplate"
                                bottom
                            >
                                <template v-slot:activator="{ on }">
                                    <icon-button
                                        :on="on"
                                        @click="showTranslations = !showTranslations"
                                    >
                                        mdi-web
                                    </icon-button>
                                </template>
                                {{ $t('Edit translations') }}
                            </v-tooltip>
                            <action-menu
                                :items="productNamePlaceholders"
                                icon="CurlyBraces"
                                :tooltip="$t('Add placeholder')"
                                @action="insertPlaceholder(productNamePlaceholders[$event].value)"
                            />
                        </v-col>
                    </v-row>
                    <div v-if="showTranslations">
                        <div class="pt-2 pb-5 mt-0 title">{{ $t("Edit translations") }}</div>
                        <div v-for="(language, index) in languages" :key="index">
                            <v-row no-gutters>
                                <v-col class="pb-0 px-1">
                                    <text-field
                                        v-model="billingItemCopy.translations.names[language.code]"
                                        :label="formatLanguageLabel({name: language.name, code: language.code})"
                                    />
                                </v-col>
                                <v-col class="shrink pt-6">
                                    <action-menu
                                        :items="productNamePlaceholders"
                                        icon="CurlyBraces"
                                        :tooltip="$t('Add placeholder')"
                                        @action="insertTranslationPlaceholder(productNamePlaceholders[$event].value, language.code)"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </div>

                    <v-row v-if="!showTranslations" no-gutters>

                        <v-row no-gutters>
                            <v-col cols="12" class="px-1">
                                <div class="pt-0 pb-6 mt-0 body-1"></div>
                            </v-col>

                            <v-col v-if="isTopicFilterVisible" cols="12" class="pt-0 px-1">
                                <dropdown
                                    :items="account_topics"
                                    :selected="selectedTopics"
                                    :disabled="Boolean(parentBillingItem)"
                                    name-key="name"
                                    value-key="id"
                                    show-selected-first
                                    multi
                                    deselect
                                    :label="$t('Billable topics')"
                                    :error-messages="billingItem.topics_error"
                                    @input="onTopicChange"
                                >
                                    <template #item.name="{ item }">
                                        <span class="mr-1">{{ item.name }}</span>
                                        <icon
                                            v-if="!item.billable"
                                            size="20"
                                            icon="non_billable"
                                            color="error"
                                        />
                                    </template>
                                </dropdown>
                            </v-col>

                            <v-col v-if="isBillableTimeVisible" cols="4" class="pt-2 px-1">
                                <ComboboxDropdown
                                    :items="billableFilters"
                                    :disabled="Boolean(parentBillingItem)"
                                    :selected="selectedBillableFilter"
                                    name-key="text"
                                    value-key="value"
                                    show-selected-first
                                    :searchable="false"
                                    :label="$t('Billable time')"
                                    :error-messages="billingItem.billable_filter_error"
                                    @input="billingItemCopy.billable_filter = $event.value"
                                />
                            </v-col>

                            <v-col v-if="isMinimumQuantityVisible" cols="4" class="pt-2 px-1">
                                <text-field
                                    :class="customizeForClient && isMinimumQuantityChanged ? 'highlight-changed' : ''"
                                    :value="billingItemCopy.invoice_quantity_min"
                                    :label="$t('Minimum quantity')"
                                    @input="billingItemCopy.invoice_quantity_min = !isNaN(Number($event)) ? Number($event) : null"
                                    @keypress="filterNumber"
                                />
                            </v-col>

                            <v-col v-if="isMinimumTimeVisible" cols="4" class="pt-2 px-1">
                                <ComboboxDropdown
                                    :text-class="customizeForClient && isMinimumTimeChanged ? 'highlight-changed' : ''"
                                    :items="minTimeOptions(true)"
                                    :selected="minTimeOptions(true).filter(x => x.value === billingItemCopy.invoice_time_min)"
                                    name-key="text"
                                    value-key="value"
                                    show-selected-first
                                    :label="$t('Minimum time')"
                                    :searchable="false"
                                    @input="billingItemCopy.invoice_time_min = $event.value"
                                />
                            </v-col>

                            <v-col v-if="isBillByTimeVisible" cols="4" class="pt-2 px-1">
                                <ComboboxDropdown
                                    :items="billByTimeOptions(!clientId, (!isMasterTemplate && clientId))"
                                    :selected="billByTimeOptions(!clientId, (!isMasterTemplate && clientId)).filter(x => x.value === billingItemCopy.bill_by)"
                                    name-key="text"
                                    value-key="value"
                                    show-selected-first
                                    :searchable="false"
                                    :label="$t('Bill tracked time by')"
                                    :error-messages="billingItem.bill_by_error"
                                    @input="billingItemCopy.bill_by = $event.value"
                                    placeholder="contract | company"
                                />
                            </v-col>

                            <v-col v-if="isBillByFieldVisible" cols="4" class="pt-2 px-1">
                                <ComboboxDropdown
                                    :items="billByFieldOptions(!clientId, (!isMasterTemplate && clientId))"
                                    :selected="billByFieldOptions(!clientId, (!isMasterTemplate && clientId)).filter(x => x.value === billingItemCopy.bill_by)"
                                    name-key="text"
                                    value-key="value"
                                    show-selected-first
                                    :searchable="false"
                                    :label="$t('Bill task field by')"
                                    :error-messages="billingItem.bill_by_error"
                                    @input="billingItemCopy.bill_by = $event.value"
                                    placeholder="contract | company"
                                />
                            </v-col>

                        </v-row>
                    </v-row>

                    <v-row v-if="!showTranslations" no-gutters>
                        <!-- external data -->
                        <v-row no-gutters>
                            <v-col cols="12" class="px-1">
                                <div class="py-4 mt-0 title">{{ $t("Integration parameters") }}
                                    <v-tooltip bottom open-delay="250">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon small v-on="on">
                                                mdi-help-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>{{ $t("Empty values will use product default") }}</span>
                                    </v-tooltip>
                                </div>
                            </v-col>

                            <template v-if="showSettings">
                                <v-col cols="6" class="pt-0 px-1">
                                    <ComboboxDropdown
                                        :items="articles"
                                        :selected="articles.filter(x => x.id === billingItemCopy.article_id)"
                                        :placeholder="getPlaceholderById('name', 'article_id', billingItemCopy, parentBillingItem, articles)"
                                        :text-class="customizeForClient && is_article_changed ? 'highlight-changed' : ''"
                                        name-key="info"
                                        value-key="id"
                                        :sort="false"
                                        show-selected-first
                                        deselect
                                        :label="$t('Article')"
                                        @input="on_article_change"
                                    />
                                </v-col>

                                <v-col cols="6" class="pt-0 px-1">
                                    <ComboboxDropdown
                                        :items="billing_projects"
                                        :selected="billing_projects.filter(x => x.id === billingItemCopy.billing_project_id)"
                                        :placeholder="getPlaceholderById('name', 'billing_project_id', billingItemCopy, parentBillingItem, billing_projects)"
                                        name-key="info"
                                        value-key="id"
                                        :sort="false"
                                        show-selected-first
                                        deselect
                                        :text-class="customizeForClient && is_billing_project_changed ? 'highlight-changed' : ''"
                                        :label="$t('Project')"
                                        @input="on_billing_project_change"
                                    />
                                </v-col>

                                <v-col cols="6" class="pt-0 px-1">
                                    <ComboboxDropdown
                                        :items="cost_centers"
                                        :placeholder="getPlaceholderById('name', 'cost_center_id', billingItemCopy, parentBillingItem, cost_centers)"
                                        :selected="cost_centers.filter(x => x.id === billingItemCopy.cost_center_id)"
                                        name-key="info"
                                        value-key="id"
                                        :sort="false"
                                        show-selected-first
                                        deselect
                                        :text-class="customizeForClient && is_cost_center_changed ? 'highlight-changed' : ''"
                                        :label="$t('Cost center')"
                                        @input="on_cost_center_change"
                                    />
                                </v-col>

                                <v-col cols="6" class="pt-0 px-1">
                                    <ComboboxDropdown
                                        :items="resources"
                                        :placeholder="getPlaceholderById('name', 'resource_id', billingItemCopy, parentBillingItem, resources)"
                                        :selected="resources.filter(x => x.id === billingItemCopy.resource_id)"
                                        name-key="info"
                                        value-key="id"
                                        :sort="false"
                                        show-selected-first
                                        deselect
                                        :text-class="customizeForClient && is_resource_changed ? 'highlight-changed' : ''"
                                        :label="$t('Resource')"
                                        @input="on_resource_change"
                                    />
                                </v-col>

                                <v-col cols="6" class="pt-0 px-1">
                                    <v-text-field
                                        :value="billingItemCopy.ext_variable"
                                        :label="$t('Custom Value')"
                                        :placeholder="getPlaceholderByValue('ext_variable', billingItemCopy, parentBillingItem)"
                                        :class="customizeForClient && is_ext_variable_changed ? 'highlight-changed' : ''"
                                        outlined
                                        @input="on_ext_variable_change"
                                    />
                                </v-col>
                            </template>
                        </v-row>
                    </v-row>
                </v-col>
                <v-col
                    cols="6"
                    class="g1 rounded-lg client-pricing"
                    :class="customizeForClient && isRowTypeChanged ? 'highlight-changed' : ''"
                >
                    <v-row v-if="!showTranslations" no-gutters>
                        <v-row no-gutters>
                            <v-col cols="6" class="px-1">
                                <div class="mt-2 mb-4 title">
                                    {{ $t("Pricing") }}
                                </div>
                            </v-col>
                        </v-row>
                    </v-row>

                    <v-row
                        v-if="!showTranslations"
                        no-gutters
                        :class="default_pricelist"
                    >
                        <v-row no-gutters>
                            <v-col
                                ref="calculateRef"
                                cols="6"
                                class="px-1"
                            >
                                <ComboboxDropdown
                                    :items="calculate_by_types"
                                    :selected="calculate_by_types.filter(x => x.value === billingItemCopy.type)"
                                    :label="$t('Calculate')"
                                    name-key="text"
                                    value-key="value"
                                    show-selected-first
                                    :deselect="false"
                                    @input="onTypeChange"
                                >
                                    <template #item.name="{ item }">
                                        <span class="mr-1">{{ item.text }}</span>
                                        <icon
                                            v-if="!item.billable && ['price', 'number'].includes(item.type)"
                                            size="20"
                                            icon="non_billable"
                                        />
                                    </template>
                                </ComboboxDropdown>
                            </v-col>
                            <v-col
                                ref="taxRef"
                                cols="4"
                                class="pt-0 px-1"
                            >
                                <ComboboxDropdown
                                    :items="taxes ? taxes : []"
                                    :placeholder="getPlaceholderById('percent', 'tax_id', billingItemCopy, parentBillingItem, taxes)"
                                    :selected="taxes ? taxes.filter(x => x.id === billingItemCopy.tax_id) : []"
                                    name-key="info"
                                    value-key="id"
                                    :sort="false"
                                    :input-text="showTaxValue(taxes, billingItemCopy)"
                                    show-selected-first
                                    :label="$t('Tax')"
                                    :error-messages="billingItemCopy.tax_id_error"
                                    :textClass="customizeForClient && is_tax_changed ? 'highlight-changed' : ''"
                                    @input="on_tax_change"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-text-field
                                    ref="discountRef"
                                    :value="formatNumber(getDiscount())"
                                    :label="$t('DC %')"
                                    :class="customizeForClient && isDiscountChanged ? 'highlight-changed' : ''"
                                    suffix="%"
                                    outlined
                                    @keypress="filterNumber"
                                    @change="setDiscount($event)"
                                />
                            </v-col>
                        </v-row>

                        <template v-if="!isPriceType">


                            <v-row>
                                <v-col cols="12">
                                    <div class="d-flex align-center">
                                        <switch-button
                                            :class="customizeForClient && isPricelistTypeChanged ? 'highlight-changed' : ''"
                                            :value="getPricelistType()"
                                            :label="$t('Sum all matching rows')"
                                            :disabled="billingItemCopy.type === 'product_default'"
                                            @change="setPricelistType($event)"
                                        />
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-icon small v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            {{ $t('When enabled, total price is a cumulative sum of all matching rows. By default, total price price only uses the highest matching row.') }}
                                        </v-tooltip>
                                    </div>
                                </v-col>
                            </v-row>

                            <template v-for="(period, index) in billingItemCopy.periods">
                                <v-row
                                    :key="index"
                                    no-gutters
                                >
                                    <v-col cols="12">
                                        <v-row no-gutters>
                                            <v-col cols="6" class="px-1">
                                                <v-menu
                                                    ref="menu"
                                                    :close-on-content-click="false"
                                                    offset-y
                                                    min-width="280"
                                                    nudge-top="19"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            :value="period.date_from | format_date"
                                                            :label="$t('Prices since')"
                                                            :error-messages="billingItem.periods[index] ? billingItem.periods[index].date_from_error : null"
                                                            :disabled="billingItemCopy.type === 'product_default'"
                                                            outlined
                                                            append-icon="event"
                                                            readonly
                                                            color="primary"
                                                            v-on="on"
                                                        />
                                                    </template>
                                                    <v-card class="date-range pb-3">
                                                        <v-date-picker
                                                            ref="picker"
                                                            v-model="period.date_from"
                                                            :locale="locale"
                                                            min="2000-01-01"
                                                            :first-day-of-week="firstDayOfWeek"
                                                            no-title
                                                            scrollable
                                                            class="elevation-0"
                                                        />
                                                    </v-card>
                                                </v-menu>
                                            </v-col>
                                            <v-col class="text-right pt-6" cols="6">
                                                <v-row
                                                    v-if="billingItemCopy.type !== 'product_default'"
                                                    no-gutters
                                                    justify="end"
                                                    align="center"
                                                >
                                                    <v-btn
                                                        icon
                                                        text
                                                        color="grey"
                                                        @click="onDeletePeriodClick(index)"
                                                    >
                                                        <v-icon
                                                            :size="24"
                                                            class="mr-0"
                                                        >
                                                            delete
                                                        </v-icon>
                                                    </v-btn>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                        <ProductPriceRow
                                            v-for="(product_price, row_index) in period.prices"
                                            :key="'ppr-' + row_index"
                                            :period-prices="period.prices"
                                            :product-price="product_price"
                                            :errors="billingItem.periods[index] && billingItem.periods[index].prices[row_index] ? billingItem.periods[index].prices[row_index] : {}"
                                            :product-type="calculatedProductType"
                                            :units="units"
                                            :ranges-available="ranges_available"
                                            :period-index="index"
                                            :row-index="row_index"
                                            :disabled="billingItemCopy.type === 'product_default'"
                                            @delete_row="onDeletePriceRangeClick"
                                        />
                                        <v-btn
                                            v-if="ranges_available && billingItemCopy.type !== 'product_default'"
                                            class="mb-3"
                                            color="primary"
                                            text
                                            @click="onAddPriceRangeClick(index)"
                                        >
                                            <v-icon
                                                size="24"
                                                left
                                            >
                                                mdi-plus-box
                                            </v-icon>
                                            {{ $t("Add price") }}
                                        </v-btn>
                                        <v-divider
                                            v-if="index !== billingItemCopy.periods.length - 1"
                                            class="mb-5"
                                        />
                                    </v-col>
                                </v-row>
                            </template>
                            <v-btn
                                v-if="billingItemCopy.type !== 'product_default'"
                                color="primary"
                                text
                                @click="onAddPeriodClick"
                            >
                                <v-icon
                                    size="24"
                                    left
                                >
                                    mdi-plus-box
                                </v-icon>
                                {{ $t("Add pricing period") }}
                            </v-btn>
                        </template>
                    </v-row>
                </v-col>
            </v-row>
        </form>

        <template
            v-if="!showTranslations && billingItem"
            slot="footer"
        >
            <slot name="footer"/>
            <secondary-button
                v-if="productId && canEdit && isMasterTemplate"
                :loading="loader.isLoading"
                @click="$emit('updateAll', billingItemCopy)">
                {{ $t('Update contracts') }}
            </secondary-button>

            <v-spacer/>

            <v-btn
                text
                color="primary"
                @click="onCloseClick"
            >
                {{ $t("Cancel") }}
            </v-btn>
            <v-btn
                v-if="canEdit || canSaveClientProduct"
                color="primary"
                class="white--text"
                :loading="loader.isLoading"
                @click="onSave"
            >
                {{ $t("Save") }}
            </v-btn>
        </template>

        <template
            v-if="showTranslations && canEdit"
            slot="footer"
        >
            <v-spacer/>
            <v-btn
                v-if="showTranslations"
                color="primary"
                class="white--text"
                @click="showTranslations = !showTranslations"
            >
                {{ $t("Confirm") }}
            </v-btn>
        </template>
        <slot/>
    </Dialog>
</template>

<script>
import Vue from "vue";
import ProductPriceRow from "../ProductPriceRow.vue";
import Dialog from "@/components/Dialog.vue";
import {$t} from "@/i18n";
import {computed, onMounted, watch, reactive, toRefs} from "@vue/composition-api";
import ProductFieldModule from "../../../store/modules/product_field";
import CustomFieldsModule from "../../../store/modules/custom_fields";
import TopicModule, {state} from "../../../store/modules/topic";
import AppModule, {state as appState} from "../../../store/modules/app";
import {formatNumber, formatMoneyNumber, formatSysDate, cleanNumber} from "../../../plugins/formatting";
import ComboboxDropdown from "../../../components/ComboboxDropdown";
import errorDialog from "@/views/ErrorDialog/errorDialog"
import {ref} from "@vue/composition-api";
import {
    billByTimeOptions,
    billByFieldOptions,
    minTimeOptions,
    productNamePlaceholders,
} from "@/helpers/constants";
import Loader from "@/utility/loader";
import RightsModule from "@/composables/use-rights";
import AccountModule from "@/store/modules/account"
import {deepClone} from "@/helpers/helpers";
import {filterNumber, translateCalculateByType, translateUnit} from "@/helpers/helpers";
import ApiTax from "../../../api/billing/tax";
import {formatLanguageLabel} from '../../../helpers/formatting'

export default {
    name: "EditProductDialog",
    methods: {formatLanguageLabel},
    computed: {},
    components: {
        Dialog,
        ProductPriceRow,
        ComboboxDropdown
    },
    props: {
        companyId: {
            type: Number,
            required: true
        },
        productId: {
            type: Number,
            default: null
        },
        clientId: {
            type: Number,
            default: null
        },
        customizeForClient: {
            // notice :: handle different radio "customize" use cases
            // "load_custom" - radio was already enabled
            // "form_changed" - user changed input values
            // "user_clicked" - user manually enabled radio
            type: [String, Boolean],
            default: ''
        },
        updatedCustomizationOptions: {
            type: Array,
            default: null
        },
        isMasterTemplate: {
            type: Boolean,
            default: false
        },
        billingItem: {
            type: Object,
            default: null
        },
        parentBillingItem: {
            type: Object,
            default: null
        },
        autoFocusField: {
            type: String,
            default: null
        },
        isBillingProductEdit: {
            type: Boolean,
            default: false
        }
    },
    setup(props, ctx) {
        const taxes = ref([])

        const nameRef = ref(null)
        const calculateRef = ref(null)
        const taxRef = ref(null)
        const discountRef = ref(null)
        const isMounted = ref(false)

        const {clearValidationErrors, handleErrorResponse, languages, fetchClassifiers} = AppModule();

        const billingItemCopy = ref(deepClone(props.billingItem))
        const loader = reactive(new Loader())
        const {can_edit_products, can_manage_client_contracts_and_invoices} = RightsModule();
        const {getAccount} = AccountModule();
        const {fetchAccountTopics, all_topics} = TopicModule();
        const {
            fetchAccountProductFields,
            get_account_articles,
            get_account_resources,
            get_account_billing_projects,
            get_account_cost_centers,
        } = ProductFieldModule();
        const {fetchCustomFields, getAccountCalculateByTypes} = CustomFieldsModule();

        const showTranslations = ref(false)
        const showSettings = ref(true)
        const changedProduct = ref(null)
        const default_pricelist = ref("")

        const getPlaceholderById = (name_field, id_field, child, parent, items) => {
            if (!items) return ''

            let item = '';
            if (!item && child && id_field in child) {
                item = items.find(x => parseInt(x.id) === parseInt(child[id_field]))
            }
            if (!item && parent && id_field in parent) {
                item = items.find(x => parseInt(x.id) === parseInt(parent[id_field]))
            }
            if (item && name_field in item) {
                return item[name_field] || ''
            }
            return ''
        }

        const getPlaceholderByValue = (name_field, child, parent) => {
            let placeholder = '';
            if (!placeholder && child) {
                placeholder = name_field in child ? child[name_field] : ''
            }
            if (!placeholder && parent) {
                placeholder = name_field in parent ? parent[name_field] : ''
            }
            return placeholder || ''
        }

        const calculatedProductType = computed(() => {
            if (billingItemCopy.value.type === 'product_default') {
                return props.parentBillingItem.type
            }
            return billingItemCopy.value.type
        })

        const accountTopics = computed(() => {
            return [
                {id: 0, name: $t("(Without topic)"), billable: 1},
                ...all_topics.value.filter(t => (t.account_id === props.companyId))
            ]
        });

        const isProductNameChanged = computed(() => {
            if (!(props.parentBillingItem && billingItemCopy.value)) {
                return false
            }

            if (props.parentBillingItem.name === billingItemCopy.value.name) {
                return false
            }

            if (props.parentBillingItem.translations && props.parentBillingItem.translations.names) {
                for (const translation of Object.values(props.parentBillingItem.translations.names)) {
                    if (translation === billingItemCopy.value.name) {
                        return false
                    }
                }
            }

            return true
        })

        const showTaxValue = (taxes, item) => {
            let result = ''
            if (taxes && item && item.tax_id) {
                const tax = taxes.find(x => x.id === item.tax_id)
                if (tax) {
                    if (tax.percent) {
                        result = tax.percent + ' %'
                    } else {
                        result = '-'
                    }
                }
            }
            return result
        }

        // bill by
        const isBillByTimeVisible = computed(() => {
            return ['total_hours', 'normal_hours', 'extra_hours'].includes(calculatedProductType.value)
        })
        const isBillByFieldVisible = computed(() => {
            return calculatedProductType.value.startsWith("custom_field/")
        })

        // topic filter visible
        const isTopicFilterVisible = computed(() => {
            return ['total_hours', 'normal_hours', 'extra_hours'].includes(calculatedProductType.value)
                || calculatedProductType.value.startsWith("custom_field/")
        })

        // time entry billable
        const isBillableTimeVisible = computed(() => {
            return ['total_hours', 'normal_hours', 'extra_hours'].includes(calculatedProductType.value)
        })

        // minimum
        const isMinimumTimeVisible = computed(() => {
            return ['total_hours', 'normal_hours', 'extra_hours'].includes(calculatedProductType.value)
        })
        const isMinimumQuantityVisible = computed(() => {
            return calculatedProductType.value === 'fixed_price' || calculatedProductType.value.startsWith("custom_field/")
        })

        const is_article_changed = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.article_id && billingItemCopy.value.article_id == null) return false;
                if (!props.parentBillingItem.article_id && !billingItemCopy.value.article_id) return false;
            }
            return props.parentBillingItem && billingItemCopy.value && props.parentBillingItem.article_id !== billingItemCopy.value.article_id;
        })

        const is_billing_project_changed = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.billing_project_id && billingItemCopy.value.billing_project_id == null) return false;
                if (!props.parentBillingItem.billing_project_id && !billingItemCopy.value.billing_project_id) return false;
            }
            return props.parentBillingItem && billingItemCopy.value && props.parentBillingItem.billing_project_id !== billingItemCopy.value.billing_project_id;
        })

        const is_resource_changed = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.resource_id && billingItemCopy.value.resource_id == null) return false;
                if (!props.parentBillingItem.resource_id && !billingItemCopy.value.resource_id) return false;
            }
            return props.parentBillingItem && billingItemCopy.value && props.parentBillingItem.resource_id !== billingItemCopy.value.resource_id;
        })

        const is_cost_center_changed = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.cost_center_id && billingItemCopy.value.cost_center_id == null) return false;
                if (!props.parentBillingItem.cost_center_id && !billingItemCopy.value.cost_center_id) return false;
            }
            return props.parentBillingItem && billingItemCopy.value && props.parentBillingItem.cost_center_id !== billingItemCopy.value.cost_center_id;
        })

        const is_ext_variable_changed = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.ext_variable && billingItemCopy.value.ext_variable == null) return false;
                if (!props.parentBillingItem.ext_variable && !billingItemCopy.value.ext_variable) return false;
            }
            return props.parentBillingItem && billingItemCopy.value && props.parentBillingItem.ext_variable !== billingItemCopy.value.ext_variable;
        })

        const isRowTypeChanged = computed(() => {
            return billingItemCopy.value && props.parentBillingItem && billingItemCopy.value.type !== 'product_default'
        })

        const is_tax_changed = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.tax_id && billingItemCopy.value.tax_id == null) return true;
                if (billingItemCopy.value.tax_id !== props.parentBillingItem.tax_id) return true;
            }
            return false
        })

        const isDiscountChanged = computed(() => {
            if (billingItemCopy.value && props.parentBillingItem && !billingItemCopy.value.discount_rate && !props.parentBillingItem.discount_rate) return false;
            return billingItemCopy.value && props.parentBillingItem && billingItemCopy.value.discount_rate !== props.parentBillingItem.discount_rate;
        })

        const isPricelistTypeChanged = computed(() => {
            let a = props.parentBillingItem && props.parentBillingItem.pricelist_type === 'cumulative' ? 'cumulative' : 'fixed';
            let b = billingItemCopy.value && billingItemCopy.value.pricelist_type === 'cumulative' ? 'cumulative' : 'fixed';
            if (a === b) return false;

            if (props.parentBillingItem && billingItemCopy.value) {
                if (props.parentBillingItem.pricelist_type && billingItemCopy.value.pricelist_type == null) return false;
                if (!props.parentBillingItem.pricelist_type && !billingItemCopy.value.pricelist_type) return false;
            }
            return props.parentBillingItem && billingItemCopy.value && props.parentBillingItem.pricelist_type !== billingItemCopy.value.pricelist_type;
        })

        const isMinimumQuantityChanged = computed(() => {
            if (!isMinimumQuantityVisible.value) {
                return false
            }
            if (billingItemCopy.value && props.parentBillingItem) {
                if (!billingItemCopy.value.invoice_quantity_min && !props.parentBillingItem.invoice_quantity_min) return false;
                return billingItemCopy.value.invoice_quantity_min !== props.parentBillingItem.invoice_quantity_min;
            }
        })

        const isMinimumTimeChanged = computed(() => {
            if (!isMinimumTimeVisible.value) {
                return false
            }
            if (billingItemCopy.value && props.parentBillingItem) {
                if (!billingItemCopy.value.invoice_time_min && !props.parentBillingItem.invoice_time_min) return false;
                return billingItemCopy.value.invoice_time_min !== props.parentBillingItem.invoice_time_min;
            }
        })

        const changedValues = computed(() => [
            is_tax_changed.value,
            is_article_changed.value,
            is_resource_changed.value,
            is_billing_project_changed.value,
            is_cost_center_changed.value,
            is_ext_variable_changed.value,

            isProductNameChanged.value,
            isRowTypeChanged.value,
            isMinimumTimeChanged.value,
            isMinimumQuantityChanged.value,
            isDiscountChanged.value,
            isPricelistTypeChanged.value,
        ])

        onMounted(async () => {
            try {
                fetchCustomFields(props.companyId, 'task', 0, false)
                fetchAccountTopics(props.companyId)
                fetchAccountProductFields(props.companyId)
                fetchClassifiers({types: ["languages"], account_id: props.companyId});
                taxes.value = await ApiTax.getTaxes(props.companyId)
            } catch (ex) {
                errorDialog.showError(ex);
            }

            // notice :: check if row already was customized
            if (changedValues.value.includes(true)) {
                ctx.emit('updateCustomizeForClient', 'load_custom')  // notice :: use case - open modal, was customized
            }
            isMounted.value = true
            await autoFocusField()
        });

        watch(() => props.customizeForClient, () => {
            if (!isMounted.value) return
            // notice :: check if user clicked radio button
            onClientPricingChange()
        })

        watch(() => changedValues.value, () => {
            if (!isMounted.value) return
            if (changedValues.value.includes(true)) {
                changedProduct.value = null
                ctx.emit('updateCustomizeForClient', 'form_changed')  // notice :: use case - user changed form values
            }
        })

        const onClientPricingChange = () => {
            if (!isMounted.value) return

            let parent = props.parentBillingItem
            let parentType = parent && parent.type ? parent.type : ''

            let child = billingItemCopy.value
            let childType = child && child.type ? child.type : ''

            if (!props.customizeForClient) {
                changedProduct.value = deepClone(child)
                child.periods = deepClone(parent.periods)
                child.name = parent.name
                child.topics = deepClone(parent.topics)
                child.pricelist_type = parent.pricelist_type
                child.billable_filter = parent.billable_filter
                child.discount_rate = parent.discount_rate
                child.invoice_time_min = parent.invoice_time_min
                child.bill_by = parent.bill_by
                child.invoice_quantity_min = parent.invoice_quantity_min

                child.article_id = parent.article_id
                child.billing_project_id = parent.billing_project_id
                child.resource_id = parent.resource_id
                child.cost_center_id = parent.cost_center_id

                child.ext_variable = parent.ext_variable
                child.tax_id = parent.tax_id
                onTypeChange({value: 'product_default'})
                ctx.emit('updateCustomizeForClient', false)

            } else {
                if (changedProduct.value) {
                    child.periods = deepClone(changedProduct.value.periods)
                    child.name = changedProduct.value.name
                    child.topics = deepClone(changedProduct.value.topics)
                    child.pricelist_type = changedProduct.value.pricelist_type
                    child.billable_filter = changedProduct.value.billable_filter
                    child.discount_rate = changedProduct.value.discount_rate
                    child.invoice_time_min = changedProduct.value.invoice_time_min
                    child.bill_by = changedProduct.value.bill_by
                    child.invoice_quantity_min = changedProduct.value.invoice_quantity_min

                    child.article_id = changedProduct.value.article_id
                    child.billing_project_id = changedProduct.value.billing_project_id
                    child.resource_id = changedProduct.value.resource_id
                    child.cost_center_id = changedProduct.value.cost_center_id

                    child.ext_variable = changedProduct.value.ext_variable
                    child.tax_id = changedProduct.value.tax_id
                    onTypeChange({value: changedProduct.value.type})

                } else {
                    // notice :: check if user enabled radio button and before was product default
                    if (props.customizeForClient === 'user_clicked' && childType === 'product_default') {
                        // notice :: then also switch billing type from default
                        onTypeChange({value: parentType})
                    }
                }
            }
        }

        const selectedTopics = computed(() => {
            if (props.parentBillingItem) {
                if (!props.parentBillingItem.topics) {
                    return []
                }
                return accountTopics.value.filter(x => props.parentBillingItem.topics.includes(x.id))
            }

            if (billingItemCopy.value.topics) {
                return accountTopics.value.filter(x => billingItemCopy.value.topics.includes(x.id))
            }
            return []
        })

        const billableFilters = computed(() => {
            return [
                {
                    text: $t('All'),
                    value: 'all'
                },
                {
                    text: $t('Billable'),
                    value: 'billable'
                },
                {
                    text: $t('Non-billable'),
                    value: 'not_billable'
                }
            ]
        })
        const selectedBillableFilter = computed(() => {
            return props.parentBillingItem ? billableFilters.value.filter(x => x.value === props.parentBillingItem.billable_filter) : billableFilters.value.filter(x => x.value === billingItemCopy.value.billable_filter)
        })

        const locale = computed(function () {
            return Vue.formatting.culture;
        });

        const firstDayOfWeek = computed(function () {
            return Vue.formatting.first_week_day;
        });

        const units = computed(() => {
            if (calculatedProductType.value === "fixed_price") {
                return [{value: "month", text: $t("Price")}];  // Period // Monthly fee
            }
            if (calculatedProductType.value.startsWith("custom_field/")) {
                return [
                    {value: "piece", text: $t("Quantity")}, // Piece price
                    {value: "month", text: $t("Fixed price")}  // Period // Monthly fee
                ];
            }
            return [
                {value: "hour", text: $t("Quantity")}, // Hourly Price
                {value: "month", text: $t("Fixed price")}  // Monthly fee
            ];
        });
        const ranges_available = computed(() => {
            if (props.parentBillingItem && billingItemCopy.value.type === 'product_default') {
                return props.parentBillingItem.type !== "fixed_price";
            }
            return billingItemCopy.value.type !== "fixed_price";
        });

        const account_topics = computed(() => {
            let no_topic = {id: 0, name: $t("(Without topic)"), billable: 1};
            let account_topics = all_topics.value.filter(t => (t.account_id === props.companyId));
            let result = [no_topic, ...account_topics];
            return result;
        });

        const calculate_by_types = computed(() => {
            let result = deepClone(getAccountCalculateByTypes(props.companyId).value)
            if (props.parentBillingItem) {
                const type_text = translateCalculateByType(props.parentBillingItem)
                const calculate_by_type_text = "{0} - {1}".format($t("Product").toUpperCase(), type_text)
                result.unshift({value: "product_default", text: calculate_by_type_text})
            }
            return result
        });

        const articles = computed(() => {
            let result = get_account_articles(props.companyId)
            return result.value
        });
        const resources = computed(() => {
            let result = get_account_resources(props.companyId)
            return result.value
        });
        const billing_projects = computed(() => {
            let result = get_account_billing_projects(props.companyId)
            return result.value
        });
        const cost_centers = computed(() => {
            let result = get_account_cost_centers(props.companyId)
            return result.value
        });

        const autoFocusField = async () => {
            await Vue.nextTick()

            // TODO: Ugly hack for set time out, wont position menu correctly otherwise

            if (props.autoFocusField === 'name') {
                nameRef.value.$el.querySelector('input').focus()
            } else if (props.autoFocusField === 'calculate') {
                setTimeout(() => {
                    calculateRef.value.querySelector('input').click()
                }, 300)
            } else if (props.autoFocusField === 'tax') {
                setTimeout(() => {
                    taxRef.value.querySelector('input').click()
                }, 300)
            } else if (props.autoFocusField === 'discount') {
                discountRef.value.$el.querySelector('input').focus()
            }
        }

        const onCloseClick = () => {
            ctx.emit("close_modal");
        };

        const onAddPeriodClick = () => {
            return billingItemCopy.value.periods.push({
                date_from: formatSysDate(new Date().calcAddMonths(0)),
                prices: [
                    {
                        range_from: null,
                        range_until: null,
                        net_price: null,
                        quantity: 1,
                        unit: units.value[0].value
                    }
                ]
            });
        };
        const onDeletePeriodClick = idx => {
            billingItemCopy.value.periods[idx].prices = [];
            return billingItemCopy.value.periods.splice(idx, 1);
        };
        const onAddPriceRangeClick = index => {
            return billingItemCopy.value.periods[index].prices.push({
                range_from: null,
                range_until: null,
                net_price: null,
                unit: units.value[0].value
            });
        };
        const onDeletePriceRangeClick = (index, row_idx) => {
            return billingItemCopy.value.periods[index].prices.splice(row_idx, 1);
        };

        const selectedUnit = computed(() => {
            if (calculatedProductType.value === 'fixed_price') {
                return 'month'
            } else if (calculatedProductType.value.includes('custom_field/')) {
                return 'piece'
            } else {
                return 'hour'
            }
        })

        const onTypeChange = data => {
            let period;
            billingItemCopy.value.type = data.value;
            billingItemCopy.value.unit = selectedUnit.value

            let calculatedType = data.value
            if (calculatedType === 'product_default') {
                calculatedType = props.parentBillingItem.type
            }

            if (calculatedType === "fixed_price") {
                for (period of Array.from(billingItemCopy.value.periods)) {
                    if (period.prices.length === 0) {
                        period.prices.push({
                            range_from: null,
                            range_until: null,
                            net_price: null,
                            unit: "month"
                        });
                    } else {
                        if (period.prices.length > 1) {
                            period.prices.splice(1);
                        }
                        period.prices[0].unit = "month";
                    }
                }
            } else {
                if (billingItemCopy.value.periods.length === 1) {
                    if (billingItemCopy.value.periods[0].prices.length === 1) {
                        if (!billingItemCopy.value.periods[0].prices[0].net_price) {
                            billingItemCopy.value.periods[0].prices[0].unit = units.value[0].value;
                        }
                    }
                }
            }

            const unit_values = Array.from(units).map(x => x.value);
            return (() => {
                const result = [];
                for (period of Array.from(billingItemCopy.value.periods)) {
                    result.push(
                        (() => {
                            const result1 = [];
                            for (let product_price of Array.from(period.prices)) {
                                if (!Array.from(unit_values).includes(product_price.unit)) {
                                    result1.push((product_price.unit = units.value[0].value));
                                } else {
                                    result1.push(undefined);
                                }
                            }
                            return result1;
                        })()
                    );
                }
                return result;
            })();
        };
        const on_tax_change = (data) => {
            billingItemCopy.value.tax_id = data.id
            billingItemCopy.value.tax_rate = data.tax_rate
            billingItemCopy.value.tax_name = data.name || ''
        };

        const onTopicChange = (e) => {
            if (e) {
                billingItemCopy.value.topics = e.map(x => x.id)
            }
        }

        const on_article_change = (e) => {
            if (e) {
                billingItemCopy.value.article_id = e.id
            }
        }
        const on_resource_change = (e) => {
            if (e) {
                billingItemCopy.value.resource_id = e.id
            }
        }
        const on_billing_project_change = (e) => {
            if (e) {
                billingItemCopy.value.billing_project_id = e.id
            }
        }
        const on_cost_center_change = (e) => {
            if (e) {
                billingItemCopy.value.cost_center_id = e.id
            }
        }

        const on_ext_variable_change = (value) => {
            billingItemCopy.value.ext_variable = value
        }

        const insertPlaceholder = value => {
            billingItemCopy.value.name += ' ' + value
        }

        const insertTranslationPlaceholder = (value, languageCode) => {
            billingItemCopy.value.translations.names[languageCode] += ' ' + value
        }

        const canEdit = computed(() => {
            const company = getAccount(props.companyId);
            return can_edit_products(company.value)
        })

        const canSaveClientProduct = computed(() => {
            const company = getAccount(props.companyId);
            return props.clientId && can_manage_client_contracts_and_invoices(company.value, props.clientId)
        })

        const getDiscount = () => {
            return isNaN(billingItemCopy.value.discount_rate) ? 0 : (Math.round(billingItemCopy.value.discount_rate * 10000) / 100)
        }
        const setDiscount = (value) => {
            value = value.replace('%', '');

            value = Number(cleanNumber(value))
            if (value > 100) {
                value = 0
            }

            value /= 100

            billingItemCopy.value.discount_rate = value
        }

        const getPricelistType = () => {
            if (billingItemCopy.value.type === 'product_default') {
                return props.parentBillingItem.pricelist_type === 'cumulative'
            } else {
                return billingItemCopy.value.pricelist_type === 'cumulative'
            }
        }
        const setPricelistType = (value) => {
            if (value)
                billingItemCopy.value.pricelist_type = 'cumulative'
            else
                billingItemCopy.value.pricelist_type = 'fixed'
        }

        const validateSave = () => {
            const errors = {}
            let success = true

            if (billingItemCopy.value.name === '') {
                errors['name_error'] = $t('Required field')
                success = false
            }

            for (const periodIndex in billingItemCopy.value.periods) {
                const period = billingItemCopy.value.periods[periodIndex]

                for (const priceIndex in period.prices) {
                    const price = period.prices[priceIndex]

                    if (!errors.periods) {
                        errors.periods = []
                    }
                    if (!errors.periods[periodIndex]) {
                        errors.periods[periodIndex] = {
                            prices: {}
                        }
                    }
                    if (!errors.periods[periodIndex]['prices'][priceIndex]) {
                        errors.periods[periodIndex]['prices'][priceIndex] = {}
                    }

                    if (price.net_price === null || price.net_price === '') {
                        errors['periods'][periodIndex]['prices'][priceIndex]['net_price_error'] = $t('Required field')
                        success = false
                    } else {
                        const cleanedPrice = cleanNumber(price.net_price)
                        if (isNaN(cleanedPrice)) {
                            errors['periods'][periodIndex]['prices'][priceIndex]['net_price_error'] = $t('Must be a number')
                            success = false
                        }
                    }
                }
            }

            ctx.emit('updateErrors', errors)
            return success
        }

        const onSave = () => {
            if (!validateSave()) {
                // Billing app product edit shows errors from backend
                if (!props.isBillingProductEdit) return
            }

            // Temporary hack to write prices for price type
            let billingItemCopyCopy = {...billingItemCopy.value}

            if (isPriceType.value) {
                billingItemCopyCopy.periods = [
                    {
                        date_from: '2020-01-01',
                        prices: [
                            {
                                net_price: 5,
                                quantity: 1,
                                range_from: 0,
                                range_until: null,
                                unit: 'month'
                            }
                        ]
                    }
                ]
            }

            ctx.emit('save', billingItemCopyCopy)
        }

        const isPriceType = computed(() => {
            const calculateByType = calculate_by_types.value.find(x => x.value === calculatedProductType.value)
            if (!calculateByType) {
                return false
            }

            return calculateByType.type === 'price'
        })

        return {
            nameRef,
            calculateRef,
            taxRef,
            discountRef,

            locale,
            calculate_by_types,
            account_topics,
            languages,
            ranges_available,

            onAddPeriodClick,
            onDeletePeriodClick,
            onAddPriceRangeClick,
            onDeletePriceRangeClick,
            onCloseClick,
            onClientPricingChange,
            onTopicChange,
            onTypeChange,

            productNamePlaceholders,
            insertPlaceholder,
            insertTranslationPlaceholder,
            loader,
            canEdit,
            canSaveClientProduct,
            isProductNameChanged,

            // integration objects
            taxes,
            articles,
            resources,
            billing_projects,
            cost_centers,
            units,

            on_tax_change,
            on_article_change,
            on_resource_change,
            on_billing_project_change,
            on_cost_center_change,
            on_ext_variable_change,

            is_tax_changed,
            is_article_changed,
            is_resource_changed,
            is_billing_project_changed,
            is_cost_center_changed,
            is_ext_variable_changed,

            isRowTypeChanged,
            default_pricelist,
            changedValues,
            billingItemCopy,

            calculatedProductType,
            showSettings,
            showTranslations,
            filterNumber,
            setDiscount,
            getDiscount,
            setPricelistType,
            getPricelistType,

            onSave,
            isDiscountChanged,
            isPricelistTypeChanged,
            translateUnit,
            translateCalculateByType,
            firstDayOfWeek,
            formatNumber,
            showTaxValue,
            getPlaceholderById,
            getPlaceholderByValue,
            isPriceType,

            selectedTopics,
            isTopicFilterVisible,

            billableFilters,
            selectedBillableFilter,
            isBillableTimeVisible,

            isMinimumQuantityChanged,
            isMinimumQuantityVisible,

            minTimeOptions,
            isMinimumTimeChanged,
            isMinimumTimeVisible,

            billByTimeOptions,
            isBillByTimeVisible,

            billByFieldOptions,
            isBillByFieldVisible,
        };
    }
};
</script>

<style scoped lang="scss">
.v-input ::v-deep input {
    font-size: 14px !important;
}

.v-select ::v-deep .v-select__selection {
    font-size: 14px !important;
}

.default_pricelist {
    border: 1px solid #eee;
    border-radius: 4px;
    background-color: #fafafa;
    padding: 10px;
    margin: 10px 0 10px 0;
}

.client_pricelist {
    background-color: darkseagreen;
}

::v-deep .highlight-changed {
    &.v-text-field {
        fieldset {
            border-color: var(--v-tretiary-base);
        }
    }
}

.client-pricing {
    border: 1px solid transparent;

    &.highlight-changed {
        border-color: var(--v-tretiary-base) !important;
    }
}

::v-deep .v-text-field {
    fieldset {
        background-color: #fff !important;
    }
}

.v-text-field {
    ::v-deep .v-text-field__suffix {
        padding-right: 8px !important;
    }
}

</style>